import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, StateConfig, StateTransferType } from '@spartacus/core';
import { CATEGORIES_MENU_FEATURE } from './categories-menu-state';
import { reducerProvider, reducerToken } from './reducers';

function mainStoreConfigFactory(): StateConfig {
  // if we want to reuse CATALOG_FEATURE const in config, we have to use factory instead of plain object
  return {
    state: {
      ssrTransfer: {
        keys: { [CATEGORIES_MENU_FEATURE]: StateTransferType.TRANSFER_STATE },
      },
    },
  };
}

@NgModule({
  imports: [
    StoreModule.forFeature(CATEGORIES_MENU_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(mainStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class CategoriesMenuStoreModule {}
